import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("a613_token", data?.token ?? "");
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full rounded-xl border border-[var(--line)] bg-white px-4 py-3 outline-none focus:border-[var(--blue)] focus:shadow-[0_0_0_4px_rgba(11,94,215,0.12)]";

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2" data-testid="admin-login-page">
      <div className="grain relative hidden overflow-hidden bg-[var(--ink)] p-12 text-white lg:flex lg:flex-col lg:justify-end">
        <div className="absolute -right-20 top-10 h-96 w-96 rounded-full bg-[var(--blue)]/50 blur-[120px]" />
        <h1 className="relative font-display text-6xl font-black italic leading-[0.95]">Deal desk.</h1>
        <p className="relative mt-4 max-w-sm text-slate-300">Review incoming applications and move them through underwriting.</p>
      </div>
      <div className="flex items-center justify-center px-5 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Link to="/" data-testid="admin-login-home-link"><img src="/brand/logo.webp" alt="613 Advance" className="h-16 w-auto" /></Link>
          <h2 className="mt-10 font-display text-3xl font-black italic">Admin sign in</h2>
          <div className="mt-8 space-y-4">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className={input} data-testid="admin-email-input" />
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className={input} data-testid="admin-password-input" />
          </div>
          {error && <p className="mt-4 text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 flex w-full items-center justify-center rounded-full bg-[var(--ink)] py-3.5 font-semibold text-white transition-colors hover:bg-[var(--blue)] disabled:opacity-70">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
